import * as PIXI from "pixi.js";
import {PredefinedPIXIAnchorPoint} from "../PredefinedPIXIAnchorPoint";
import data from "./configs/data";
import {CustomSpineAnimation} from "./CustomSpineAnimation";

export class HandHighlighter extends PIXI.Container {

    private static readonly ARROW_ANIMATION_CONFIG = {
        NAME: "arrow",
        STATES: {
            MOVE_RIGHT_LEFT: "arrow",
        },
    };

    private readonly ARROW_POSITION = new PIXI.Point(-75, -40);

    private arrowAnimation: CustomSpineAnimation;

    constructor() {
        super();
        this.createAndAddArrowAnimation();
        // this.createAndAddLightSpot();
    }

    public showArrow(): void {
        this.arrowAnimation.visible = true;
    }

    public hideArrow(): void {
        this.arrowAnimation.visible = false;
    }

    private createAndAddLightSpot(): void {
        const lightUnderCards: PIXI.Sprite = PIXI.Sprite.fromImage(data.images.lightUnderCards);
        lightUnderCards.anchor = PredefinedPIXIAnchorPoint.CENTER;
        this.addChild(lightUnderCards);
    }

    private createAndAddArrowAnimation(): void {
        this.arrowAnimation = new CustomSpineAnimation(HandHighlighter.ARROW_ANIMATION_CONFIG.NAME);
        this.arrowAnimation.play(HandHighlighter.ARROW_ANIMATION_CONFIG.STATES.MOVE_RIGHT_LEFT, true);
        this.arrowAnimation.position = this.ARROW_POSITION;
        this.addChild(this.arrowAnimation);
    }
}



// WEBPACK FOOTER //
// ./src/app/HandHighlighter.ts